import React from 'react';

type componetRegisterType = [string, () => Promise<{ default: React.ComponentType }>, string[]];

// Register Modules
export const components: componetRegisterType[] = [
  // [MODULE_NAME, COMPONENT, [STYLES MODULES]]
  ['audit-trail-ui', () => import('../modules/history/App'), ['testsigma-atoms']],
];
